import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import "../style.scss";
import { formatDate } from "../../../formatDate";
import Loader from "../../../settings/loader";
import { useAppContext } from "../../../../AppContext";
import { useLocation, useMatch } from "react-router-dom";

function Account() {
  const location = useLocation();
  const match = useMatch("/app/account/*");
  const { user, chimeraserv, components } = useAppContext();
  const props = { user, chimeraserv, components };
  const [title] = useState("My Account | Chimera Solutions | Insights");
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);

  const headers = {
    Authorization: props.user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  useEffect(() => {
    let isMounted = true;
    const loadData = async () => {
      try {
        const response = await axios.get(
          props.chimeraserv.urlGet + "/user/" + props.user.data.id,
          { headers }
        );
        const result = response.data;

        if (isMounted) {
          setData(Array.isArray(result) ? result : [result]);
          setLoad(true);
        }
      } catch (error) {
        if (isMounted) {
          setData([]);
          setLoad(true);
        }
      }
    };
    loadData();
    return () => {
      isMounted = false;
    };
  }, [props.chimeraserv.urlGet, props.user.data.id]);

  return (
    <div className={["viewContainer", "account"].join(" ")}>
      <div className={["custForm", "custView"].join(" ")}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <div className={["viewTitle"]}>Account</div>
        {!load ? (
          <Loader />
        ) : (
          <div className={["account", "form"].join(" ")}>
            {data.map((data, key) => (
              <div key={key}>
                <div className={["form-group"]}>
                  <label>Username</label>
                  <div className={["field", "value"].join(" ")}>
                    {data.username}
                  </div>
                </div>
                <div className={["form-group"]}>
                  <label>Email</label>
                  <div className={["field", "value"].join(" ")}>
                    {data.email}
                  </div>
                </div>
                <div className={["form-group"]}>
                  <label>Modified</label>
                  <div className={["field"]}>
                    {data.modified ? formatDate.long(data.modified / 1000) : ""}
                  </div>
                </div>
                <Link
                  to={
                    location.pathname.split("/").splice(0, 2).join("/") +
                    "/user/edit-account/" +
                    data._id
                  }
                  className={["btn btn-primary"]}
                >
                  Edit
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Account;
